<template>
  <!-- 時間外報告一覧 -->
  <div id="monthlyreport">
    <CCard>
      <CCardHeader><h2>予定超過残業の申請一覧</h2></CCardHeader>
      <CCardBody>
        <table class="table search-table">
          <tr>
            <th style="width: 100px">年月</th>
            <th style="width: 75px"></th>
            <th style="width: 50px"></th>
            <!-- 絞り込みの見出しぶん。年月の行に列を足したので幅も足す -->
            <th style="width: 75px"></th>
            <th colspan="2"></th>
          </tr>
          <tr>
            <td>
              <select
                class="custom-select preika-control--year"
                v-model="year"
              >
                <option
                  v-for="option in yearOption"
                  :value="option.id"
                  :key="option.id"
                >
                  {{ option.name }}
                </option>
              </select>
            </td>
            <td>
              <select
                class="custom-select preika-control--month"
                v-model="month"
              >
                <option
                  v-for="option in monthOption"
                  :value="option.id"
                  :key="option.id"
                >
                  {{ option.name }}
                </option>
              </select>
            </td>
            <td>業務分</td>
            <td>絞り込み</td>
            <td>
              <!-- 年月と同じ検索ボタンで送る。別の検索ボックスは置かない -->
              <input
                v-model="keyword"
                type="text"
                class="form-control"
                maxlength="100"
                placeholder="社員番号・氏名・所属で絞り込む"
                @keyup.enter="search"
              />
            </td>
            <td>
              <button class="btn btn-primary" @click="search">検索</button>
            </td>
          </tr>
        </table>
      </CCardBody>
      <template v-if="callFlg">
        <CCardBody>
          <!-- 0件（絞り込みに当たるものが無いときも）は、ほかの一覧と同じ文を、同じ案内の字で、表のすぐ上に出す。 -->
          <p v-if="emptyNote" class="text-muted">{{ emptyNote }}</p>
          <div class="table-responsive">
            <table class="table table-bordered preika-report-list-table">
              <thead>
                <tr>
                  <th scope="col">社員名</th>
                  <th scope="col">予定時間外時間</th>
                  <th scope="col">発生理由</th>
                  <th scope="col">更新日</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="item in items" :key="item.id">
                  <td>
                    <router-link
                      :to="{
                        name: overTimesMsterInfo,
                        params: { id: item.id },
                      }"
                      >{{ item.user_name }}</router-link
                    >
                  </td>
                  <td class="preika-report-list-table__duration">{{ item.overtime }}H</td>
                  <td class="preika-report-list-table__reason">{{ item.reason }}</td>
                  <td class="preika-report-list-table__date">{{ formatDate(item.updated_at) }}</td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="d-flex justify-content-center">
            <VPagination
              v-model="currentPage"
              :click-handler="changePage"
              :page-count="totalPages"
              :force-page="currentPage"
              :force-ellipses="true"
              :container-class="'pagination'"
              :page-class="'page-item'"
              :prev-text="'<'"
              :next-text="'>'"
              :prev-link-class="'page-link'"
              :next-link-class="'page-link'"
              :page-link-class="'page-link'"
              :class-prefix="'pagination'"
            />
          </div>
        </CCardBody>
      </template>
    </CCard>
  </div>
</template>

<script>
import ConstList from "../../ConstList";
import { requestFailureMessage } from '@/utils/requestFailure';
import axios from "axios";
import moment from "moment";
import VPagination from "vuejs-paginate";
export default {
  name: "MonthlyReport",
  components: {
    VPagination,
  },
  data() {
    return {
      year: "",
      month: "",
      /* いま効いている絞り込みの言葉。空なら絞り込んでいない */
      keyword: "",
      date: "",
      items: [],
      // 一覧を読み終えたか（読み込み中・失敗のときは false。0件の文を出すかどうかに使う）
      listLoaded: false,
      // 検索ごとの通し番号。最新の検索の応答だけが、一覧・0件の文・保存する検索条件を変える（古い応答は捨てる）
      listRequestNo: 0,
      callFlg: false,
      type_options: [ConstList.ALLDAY, ConstList.MORNING, ConstList.AFTERNOON],
      overTimesMsterInfo: "",
      currentPage: 1,
      pageSize: 10,
      totalPages: 1,
    };
  },
  created() {
    this.yearOption = ConstList.YEAR_OPTION;
    this.monthOption = ConstList.MONTH_OPTION;
    this.overTimesMsterInfo = ConstList.ROUTE_OVERTIMES_MASTERINFO;
  },

  computed: {
    // 0件のときの案内。一覧を読み終えて0件のときだけ出す（開き直したときは読み込む前に表が出るので、件数だけでは決めない）。
    emptyNote: function () {
      return this.listLoaded && Array.isArray(this.items) && this.items.length === 0 ? ConstList.EMPTY : '';
    },
  },
  methods: {
    /**
     * 検索ボタン・入力欄のEnterから呼ぶ。
     *
     * ページを1へ戻してから引き直す。5ページ目のまま絞り込むと、
     * 結果が1ページしか無いときに空の表になる。
     */
    search: function () {
      this.currentPage = 1;
      this.callList();
    },
    callList: function () {
      this.listLoaded = false;
      /*
       * **検索を重ねても、最新の検索の結果だけを画面に出す。**
       * 応答は頼んだ順に返るとは限らない。先の検索があとから返ると、新しい結果を古い結果で上書きし、
       * 古い検索の0件の文が、新しい検索の途中や失敗のあとにも出ていた。
       * 保存する検索条件も、返ったときの画面の値ではなく、頼んだときの値にする。
       */
      const requestNo = ++this.listRequestNo;
      const asked = {
        year: this.year,
        month: this.month,
        keyword: this.keyword,
        currentPage: this.currentPage,
        pageSize: this.pageSize,
      };
      this.callFlg = false;
      const params = new URLSearchParams();
      params.append("year", this.year);
      params.append("month", this.month);
      this.fetchTotalPages();
      params.append("currentPage", this.currentPage);
      params.append("pageSize", this.pageSize);
      params.append("totalPages", this.totalPages);
      axios
        .get(process.env.VUE_APP_API_ORIGIN + "/admin/overtime", {
          params: {
            year: this.year,
            month: this.month,
            currentPage: this.currentPage,
            pageSize: this.pageSize,
            // 空文字は渡さない。渡すと「空で絞り込む」形になりうる
            keyword: this.keyword || undefined,
          },
        })
        .then((response) => {
          // 古い検索の応答は捨てる。
          if (requestNo !== this.listRequestNo) return;
          this.items = response.data;
          this.listLoaded = true;
          this.items.forEach((element) => {
            element.start_time = this.type_options[element.start_time - 1];
            element.end_time = this.type_options[element.end_time - 1];
          });

          this.callFlg = true;
          sessionStorage.setItem(
            "overtimeList-search-items",
            JSON.stringify(this.items)
          );
          sessionStorage.setItem(
            "overtimeList-search-params",
            JSON.stringify({
              year: asked.year,
              month: asked.month,
              // 戻ってきたときに年月と同じように絞り込みも復元する
              keyword: asked.keyword,
              currentPage: asked.currentPage,
              pageSize: asked.pageSize,
              totalPages: this.totalPages,
            })
          );
        })
        .catch((error) => {
        // 失敗の記録は、古い検索のものでも今までどおり送る（不具合を追う手がかり。記録を減らさない）。
        // 知らせを出すのは、記録を送り終えた時点でも最新の検索のときだけ（下のコールバックで確かめる）。
        axios
          .post(
            `${process.env.VUE_APP_API_ORIGIN}/error/frontError`,
            { error: String(error) },
            {
              headers: {
                'Content-Type': 'application/json'
              }
            }
          )
          .then(() => {
            // 記録を送るのを待つあいだに次の検索が始まっていたら、古い検索の失敗は知らせない（記録は送ってある）。
            if (requestNo !== this.listRequestNo) return;
            alert(requestFailureMessage(error));
          })
          .catch(() => {
            // 記録を送るのを待つあいだに次の検索が始まっていたら、古い検索の失敗は知らせない（記録は送ってある）。
            if (requestNo !== this.listRequestNo) return;
            alert(requestFailureMessage(error, ConstList.SYSTEM_COMMUNICATION_ERROR));
          })
        });
    },
    changePage: function (page) {
      this.currentPage = page;
      this.callList();
    },
    fetchTotalPages: function () {
      // 一覧と同じ検索の通し番号（callList が進めたあとに呼ばれる）。最新の検索の件数だけが、ページ数を変える。
      // 先の検索の件数があとから返ると、新しい検索の一覧に、古い検索のページ数が付いていた。
      const requestNo = this.listRequestNo;
      const params = new URLSearchParams();
      params.append("year", this.year);
      params.append("month", this.month);
      axios
        .get(process.env.VUE_APP_API_ORIGIN + "/admin/count", {
          params: {
            year: this.year,
            month: this.month,
            // 一覧と同じ絞り込みで数える。片方だけだと件数がずれる
            keyword: this.keyword || undefined,
          },
        })
        .then((response) => {
          // 古い検索の件数は捨てる。
          if (requestNo !== this.listRequestNo) return;
          const totalCount = response.data;
          // **ページ数は最低1。**Math.ceil(0 / 10) は 0 で、0件のときに
          // ページャそのものが消えてしまう。
          this.totalPages = Math.max(1, Math.ceil(totalCount / this.pageSize));
          // 数え直したあとに、見ているページを 1〜totalPages へ収める。
          // 覚えていたページへ戻ったとき、そのあいだに件数が減っていると
          // 空の表になるので、収めた側で引き直す。
          const inRange = Math.min(Math.max(1, this.currentPage), this.totalPages);
          if (inRange !== this.currentPage) {
            this.currentPage = inRange;
            this.callList();
          }
        })
        .catch((error) => {
        // 失敗の記録は、古い検索のものでも今までどおり送る（不具合を追う手がかり。記録を減らさない）。
        // 知らせを出すのは、記録を送り終えた時点でも最新の検索のときだけ（下のコールバックで確かめる）。
        axios
          .post(
            `${process.env.VUE_APP_API_ORIGIN}/error/frontError`,
            { error: String(error) },
            {
              headers: {
                'Content-Type': 'application/json'
              }
            }
          )
          .then(() => {
            // 記録を送るのを待つあいだに次の検索が始まっていたら、古い検索の失敗は知らせない（記録は送ってある）。
            if (requestNo !== this.listRequestNo) return;
            alert(requestFailureMessage(error));
          })
          .catch(() => {
            // 記録を送るのを待つあいだに次の検索が始まっていたら、古い検索の失敗は知らせない（記録は送ってある）。
            if (requestNo !== this.listRequestNo) return;
            alert(requestFailureMessage(error, ConstList.SYSTEM_COMMUNICATION_ERROR));
          })
        });
    },
    formatDate(dateStr) {
      if (!dateStr) return '';
      const [yyyy, mm, dd] = dateStr.split('-');
      return `${yyyy}/${mm}/${dd}`;
    },
  },
  mounted: function () {
    // **確かめる鍵と、読む鍵を同じにする。**別の鍵（-items）の有無で
    // 判定して -params を読むと、片方だけ残っているときに
    // JSON.parse(null) で落ちる。
    const saved = sessionStorage.getItem("overtimeList-search-params");
    if (saved) {
      const params = JSON.parse(saved);
      this.year = params.year;
      this.month = params.month;
      // 古い保存分には keyword が無いので、その場合は絞り込み無しに戻す
      this.keyword = params.keyword || "";
      // **見ていたページへ戻す。**保存しているのだから復元する。
      // 件数が減っていることがあるので、数え直したあと
      // （fetchTotalPages）に 1〜totalPages へ収める。
      this.currentPage = Number(params.currentPage) || 1;
      this.callList();
      this.callFlg = true;
    } else {
      const today = moment().subtract(1, 'months');
      this.year = today.format("YYYY");
      this.month = today.format("M");
    }
  },
};
</script>
